import { BestofApp } from './versions/bestof';

function App() {
  return <BestofApp />;
}

export default App;
